<template>
  <header :class="['header', { 'header--scrolled': isScrolled }]">
    <div class="header__container">
      <div class="header__logo">
        <img src="../assets/img/logo1.png" alt="Iridea Logo" />
      </div>
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        text-color="#464646"
        active-text-color="#898989"
        router
        :ellipsis="false"
        class="header__nav"
      >
        <el-menu-item index="/home">首页</el-menu-item>
        <el-menu-item index="/product">产品</el-menu-item>
      </el-menu>
    </div>
  </header>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  setup() {
    const state = computed(() => useStore().state.client);
    const activeIndex = ref("/home");
    const isScrolled = ref(false);
    const route = useRoute();

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 0;
    };

    onMounted(() => window.addEventListener("scroll", handleScroll));
    onUnmounted(() => window.removeEventListener("scroll", handleScroll));

    watch(
      () => route.path,
      (path) => {
        activeIndex.value = path.startsWith("/product") ? "/product" : "/home";
      },
      { immediate: true }
    );

    return {
      state,
      activeIndex,
      isScrolled,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: $header-height;
  background: rgba(255, 255, 255, 0.95);
  transition: box-shadow $transition-base, background $transition-base;

  &--scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: $shadow-md;
  }

  &__container {
    width: $container-width;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  &__logo {
    flex: 0 0 auto;
    img {
      height: 0.5rem;
      width: auto;
      object-fit: contain;
    }
  }

  &__nav {
    flex: 0 0 auto;

    .el-menu-item {
      font-size: 0.18rem;
      letter-spacing: 0.04em;
      padding: 0 0.3rem;
    }
  }
}
</style>
